import { deltaGptHistoryApi } from '@/api/deltaGpt/deltaGptHistoryApi.ts';
import { IConversationSummary } from '@/interfaces/deltaGpt/IConversationSummary.ts';
import { IUserAiHistory } from '@/interfaces/deltaGpt/IUserAiHistory.ts';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeltaGptHistoryStore = defineStore('deltaGptHistoryStore', () => {
    const userHistory = ref<Array<IConversationSummary> | null>(null);
    const currentChatMessageHistory = ref<Array<IUserAiHistory>>([]);
    const currentChatHistoryId = ref<string | null>(null);
    const redirectFromHistory = ref<boolean>(false);

    async function GetUsersConversationSummary (): Promise<void> {
        const history = await deltaGptHistoryApi.GetUsersConversationSummary();
        userHistory.value = history;
    }

    async function getChatMessageHistoryById (conversationId: string): Promise<Array<IUserAiHistory>> {
        return deltaGptHistoryApi.getChatMessageHistoryById(conversationId);
    }

    return {
        currentChatHistoryId,
        userHistory,
        currentChatMessageHistory,
        redirectFromHistory,
        GetUsersConversationSummary,
        getChatMessageHistoryById,
    };
});
